import React, { Suspense, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const LazyRender = ({ children, height = "370px", id }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (inView) setIsVisible(true);
  }, [inView]);

  return (
    <section ref={ref} id={id} style={{ minHeight: height }}>
      {isVisible && (
        <Suspense fallback={<div style={{ height }}>Loading...</div>}>
          {children}
        </Suspense>
      )}
    </section>
  );
};

export default LazyRender;